import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const managerRoutes: RouteConfig = {
  path: '/manager',
  component: Layout,
  meta: {
    title: 'adminMgt',
    icon: 'peoples',
    redirect: '/manager/list'
    // alwaysShow: true
  },
  children: [
    {
      path: 'list',
      name: 'User List',
      component: () => import('@/views/manager/list.vue'),
      meta: {
        title: 'adminMgt',
        icon: 'players',
        activeMenu: '/manager/list'
      }
    },
    {
      path: 'log',
      name: 'Log',
      component: () => import('@/views/manager/log.vue'),
      meta: {
        title: 'log',
        icon: 'education',
        activeMenu: '/manager/log'
      }
    },
    {
      path: 'loginLog',
      name: 'login Log',
      component: () => import('@/views/manager/loginLog.vue'),
      meta: {
        title: 'loginLog',
        icon: 'documentation',
        activeMenu: '/manager/loginLog'
      }
    },
    {
      path: 'accessDevice',
      name: 'access device',
      component: () => import('@/views/manager/accessDevice.vue'),
      meta: {
        title: 'accessDevice',
        icon: 'documentation',
        activeMenu: '/manager/accessDevice'
      }
    }
  ]
}

export default managerRoutes
